module.exports = __webpack_public_path__ + "img/hr-boiler-S-fire.679e319f.png";